// extracted by mini-css-extract-plugin
export default {"shareButton":"ProfilePage_shareButton__ZuwaK","shareIcon":"ProfilePage_shareIcon__H-QoQ"};